import { Injectable } from "@angular/core";
import { List } from "immutable";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { AddressSuccess } from "src/app/models/address";
import { LoginNameService } from "src/app/services/login-name.service";

@Injectable()
export class OnelapCheckoutLoginEventService{

    constructor(private _cookie: CookieService, private _login: LoginNameService){}
    paymentTransaction: BehaviorSubject<boolean>= new BehaviorSubject<boolean> (false);
    userExist:BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    otpEvent: BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    showRefferalCodeEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean> (false);
    showPhoneNumberInput:BehaviorSubject<boolean> = new BehaviorSubject<boolean> (true);
    logInEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    resetPasswordEvent: BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    onelapCoinsEvent:BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    addressEvent: BehaviorSubject<any>= new BehaviorSubject<any>(null);
    userDetail:BehaviorSubject<any>= new BehaviorSubject<any>(null);
    loginPasswordErrorEvent:BehaviorSubject<any> = new BehaviorSubject<any>(null);
    personalEvent:BehaviorSubject<any>= new BehaviorSubject<any>(null);
    billingAddressEvent: BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    shippingAddressEvent: BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    selectBillingAddressEvent: BehaviorSubject<any>= new BehaviorSubject<any> (null);
    selectShippingAddressEvent: BehaviorSubject<any>= new BehaviorSubject<any>(null);
    showBillingFormEvent:BehaviorSubject<boolean>= new BehaviorSubject<any>(false);
    showShippingFormEvent:BehaviorSubject<boolean>= new BehaviorSubject<boolean>(false);
    lighteningEvent:BehaviorSubject<boolean> = new BehaviorSubject<boolean> (false);
    lighteningErrorEvent:BehaviorSubject<boolean>= new BehaviorSubject<any> (null);
    serverSideErrorNotificationEvent: BehaviorSubject<any>= new BehaviorSubject<any> (null);

    getPaymentTransactionEvent(){
        return this.paymentTransaction.asObservable();
    }
    
    isPaymentTransactionEvent(isPaymentExist:boolean){
        
        this.paymentTransaction.next(isPaymentExist);
    }
  
    getUserExistEvent(){
        return this.userExist.asObservable();
    }
    isUserExistEvent(isUserExist:boolean){
        this.userExist.next(isUserExist);
    } 

    getOtpEvent(){
        return this.otpEvent.asObservable();
    }
    isOtpGenerated(otpGenerated:boolean){
        this.otpEvent.next(otpGenerated);
    }

    getRefferalCodeEvent(){
        return this.showRefferalCodeEvent.asObservable()
    }
    isRefferalCode(showRefferalCode:boolean){
        this.showRefferalCodeEvent.next(showRefferalCode);
    }

    getShowPhoneNumberEvent(){
        return this.showPhoneNumberInput.asObservable();
    }
    isShowPhoneNumber(showPhoneNumber:boolean){
        this.showPhoneNumberInput.next(showPhoneNumber);
    }

    getLogInEvent(){
        return this.logInEvent.asObservable();
    }
    isLogIn(login:boolean){
        this.logInEvent.next(login);
    }

    getResetPasswordEvent(){
        
        return this.resetPasswordEvent.asObservable();
    }
    isResetPassword(reset:boolean){
        
        this.resetPasswordEvent.next(reset);
    }

    getOnelapCoinsEvent(){
        return this.onelapCoinsEvent.asObservable();
    }
    isOnelapCoin(onelapCoin:boolean){
        this.onelapCoinsEvent.next(onelapCoin);
    }

    getAddressEvent(){
        return this.addressEvent.asObservable();
    }
    isAddress(address:any){
        return this.addressEvent.next(address);
    }

    getLoginPasswordErrorEvent(){
        return this.loginPasswordErrorEvent.asObservable();
    }
    isLoginPasswordErrorEvent(error:any){
    
        return this.loginPasswordErrorEvent.next(error);
    }

    getPersonalEvent(){
       
        return this.personalEvent.asObservable();
    }
    isPersonal(personal:any){
    
        this.personalEvent.next(personal);
    }

    getBillingAddressEvent(){
        return this.billingAddressEvent.asObservable();
    }
    isBillingAddress(billingAddress){
        this.billingAddressEvent.next(billingAddress);
    }

    getShippingAddressEvent(){
        return this.shippingAddressEvent.asObservable();
    }
    isShippingAddress(shippingAddress:any){
        return this.shippingAddressEvent.next(shippingAddress);
    }

    isSelectedShippingAddress(shippingAddress:any){
        this.selectShippingAddressEvent.next(shippingAddress);
    }

    getSelectedShippingAddressEvent(){
        return this.selectShippingAddressEvent.asObservable();
    }

    isSelectedBillingAddress(billingAddress:any){
    
        this.selectBillingAddressEvent.next(billingAddress);
    }
    getSelectedBillingAddressEvent(){
        return this.selectBillingAddressEvent.asObservable();
    }

    isShowBillingForm(isBillingForm:boolean){
        this.showBillingFormEvent.next(isBillingForm);
    }
    getShowBillingFormEvent(){
        return this.showBillingFormEvent.asObservable();
    }

    isShowShippingForm(isShippingForm:boolean){
        this.showShippingFormEvent.next(isShippingForm);
    }
    getShowShippingFormEvent(){
        return this.showShippingFormEvent.asObservable();
    }   
    isLightening(isLightening:boolean){
        this.lighteningEvent.next(isLightening);
    }
    getLighteningEvent(){
        return this.lighteningEvent.asObservable();
    }
    isLighteningError(error:any){
         this.lighteningErrorEvent.next(error);
    }
    getLighteningErrorEvent(){
        return this.lighteningErrorEvent.asObservable();
    }
    isServerSideError(error:any){
        this.serverSideErrorNotificationEvent.next(error);
    }
    getServerSideErrorEvent(){
        return this.serverSideErrorNotificationEvent.asObservable();
    }

    initAddressArray(data) {
        const billingAddresses:List<AddressSuccess> = List(data.body.billingAddresses);
        const shippingAddresses:List<AddressSuccess> = List(data.body.shippingAddresses);
        const addressArray = billingAddresses.merge(shippingAddresses);
        this.isAddress(data);
        if (this._cookie.check("addressId")) {
          billingAddresses.forEach(x => {
            if (this._cookie.get("addressId") == x.addressId) {
                this.isSelectedBillingAddress(x);
            }
          })
        }
    
        if (this._cookie.check("shippingAddressId")) {
          shippingAddresses.forEach(y => {
            if (this._cookie.get("shippingAddressId") == y.addressId) {
              this.isSelectedShippingAddress(y);
            }
          })
        }
    
        if (this._cookie.check("quickBuyId")) {
          const isShippable = this._cookie.get("shippable") == "true" ? true : false;
          if (!this._cookie.check("shippingAddressId")) {
            if (isShippable) {
              this.isShippingAddress(false);
            }
          }
          else {
            this.isShippingAddress(true);
          }
    
          if (this._cookie.check("addressId")) {
            this.isBillingAddress(true);
       
          } else {
            this.isBillingAddress(false);
         
          }
        }
    
        else {
          if (this._cookie.check("addressId")) {
            this.isBillingAddress(true);
        
          } else {
            this.isBillingAddress(false);
        
          }
    
          if (this._cookie.check("shippingAddressId")) {
            this.isShippingAddress(true);
        
          } else {
            this.isShippingAddress(false);
        
          }
        }
    
        if(shippingAddresses.isEmpty()){
            this.isShippingAddress(false)
          this.isShowShippingForm(true);
        }
        if(billingAddresses.isEmpty()){
            this.isBillingAddress(false)
          this.isShowBillingForm(true);
        }
    }

}